import { FaArrowCircleDown, FaArrowCircleUp, FaQuestion } from 'react-icons/fa'
import '../styles/Faq.css'
import React, { useState } from 'react';


function Faq() {

// State to manage open/close status of each FAQ item
const [openItems, setOpenItems] = useState([false, false, false, false, false, false]);

// Toggle function for a specific FAQ item
const toggleItem = (index) => {
  setOpenItems((prevOpenItems) =>
    prevOpenItems.map((isOpen, i) => (i === index ? !isOpen : isOpen))
  );
};

// Sample FAQ data
const faqs = [
    { question: 'I am new here, how do i make a purchase?', answer: 'Simply create an account, signin, fund your waller and proceed to purchase your desired product.' },
    { question: 'Is JcoteckVTU worth trusting? ', answer: 'Sure, you can. We are legitimate business firm duly registered with Corporate Affairs Commission (CAC) of Nigeria. Hence, be rest assured that your transactions with us are safe, secure and reliable' },
    { question: 'Will my transaction be fulfilled immediately i make payment? ', answer: 'Yes, as our services are automated for instant delivery of all products. That is all transactions have be designed to be executed automatically.' },
    { question: 'How do i fund my wallet? ', answer: 'YYou can fund your wallet through ATM card payment and your balance will be updated automatically' },
    { question: 'How do i become a resseller?', answer: 'You will have to upgrade to our premium plan with a one time fee of 2000 ' },
    { question: 'Your question not covered?', answer: 'Kindly contact our customer support team on 07054974199 (whatsapp only) for instant feedback ' },
  ];




    return ( 
    <section className = 'faq-section text-dark2 dark:text-light1' id='faq-section'>
        <div className = 'faq-div space-y-4' >
            <h1 className = 'faq-h1 ' data-aos="zoom-in" data-os-duration="1000"> FAQs < /h1> 
            <h2 className = 'faq-h2'data-aos="fade-down" data-os-duration="1200"> What you should know < /h2> 
            <div className='flex flex-col lg:flex-row lg:space-x-8 space-y-4'>

                <div className='lg:w-96 h-80 bg-light2 dark:bg-dark2 rounded-full flex items-center justify-center 
                text-primary ' data-aos="fade-right" data-os-duration="1000">
                  <FaQuestion className='h-64 w-auto opacity-60' />
                </div>
            
                <div className = "flex flex-col  items-start lg:w-7/10" > 
                    
                {faqs.map((faq, index) => (
                    <div
                    className=' bg-light2  dark:bg-dark2 p-2 my-2 w-full rounded-lg' data-aos="fade-left" data-os-duration="1000"
                    key={index}>
                    
                    <div className='flex justify-between items-center text-left'
                    onClick={() => toggleItem(index)} style={{ cursor: 'pointer' }}>
                      <span> {faq.question}</span> <span className='ml-2'>
                            {openItems[index]? <FaArrowCircleUp className='w-6 h-6 text-dark0 hover:text-primary ' />:<FaArrowCircleDown className='w-6 h-6 text-dark0 hover:text-primary ' /> }
                        </span>
                    </div>
                    {openItems[index] && <p className="text-left text-dark0">{faq.answer}</p>}
                    </div>
                ))}
                </div > 
            </div>
        </div > 
    </section >
    );
}

export default Faq;